// extracted by mini-css-extract-plugin
export default {"actions":"Practices_actions__iachL","card":"Practices_card__29O1n"};